<template>
	<draggable
		:disabled="disabled"
		:list="list"
		:move="checkMove"
		:handle="handle && '.handle'"
		v-bind="dragOptions"
		@start="dragStart"
		@end="dragEnd"
	>
		<slot />
	</draggable>
</template>
<script>
import { defineComponent } from "vue";
import draggable from "vuedraggable";

export default defineComponent({
	name: "DragDropList",
	components: {
		draggable
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		list: {
			type: Array,
			default: null
		},
		/**
		 * handle value will decide from the point, the things must be dragged, for eg: we may use an Icon for dragging the things out and icon must be having a class='handle'
		 */
		handle: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				group: "description",
				disabled: false,
				ghostClass: "ghost"
			};
		}
	},
	methods: {
		checkMove(e) {
			// window.console.log(`Future index: ${e.draggedContext.futureIndex}`);
			/**
			 * What needs to be done while moving the items
			 */
			this.$emit("move", e);
		},
		dragStart() {
			/**
			 * What needs to be done on start of the drag
			 */
			this.$emit("dragStart");
		},
		dragEnd() {
			/**
			 * What needs to be done on the end of the drag
			 */
			this.$emit("dragEnd");
		}
	}
});
</script>
<style lang="scss">
.ghost {
	opacity: 0;
	background: #c8ebfb;
}
</style>
